<button
  *ngIf="action.iconName"
  (click)="triggerAction(action.actionId)" >
  <i
    [className]="typeof(action.iconName) === 'function' ? action.iconName(row) : action.iconName"
    [id]="action.actionId"
    aria-hidden="true"
    [ngStyle]="{'background-color': row.shade || 'transparent'}">
  </i>
</button>
